export const QUESTIONS = [
  {
    id: "q1",
    title: "Do you currently have a will or trust?",
    type: "single",
    options: [
      { value: "both", label: "Yes, both" },
      { value: "will", label: "Yes, a will" },
      { value: "trust", label: "Yes, a trust" },
      { value: "no", label: "No" },
      { value: "unsure", label: "I'm not sure" },
    ],
  },
  {
    id: "q2",
    title: "Do you own a home or other real estate?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    id: "q3",
    title: "Do you have children or anyone who financially depends on you?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    id: "q4",
    title: "Do you currently have life insurance?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "unsure", label: "I'm not sure" },
    ],
  },
  {
    id: "q4_coverage",
    title: "Approximately how much coverage do you currently have?",
    type: "single",
    conditional: (answers) => answers.q4 === "yes",
    options: [
      { value: "under50k", label: "Under $50,000" },
      { value: "50_100k", label: "$50,000–$100,000" },
      { value: "100_250k", label: "$100,001–$250,000" },
      { value: "250_500k", label: "$250,001–$500,000" },
      { value: "over500k", label: "Over $500,000" },
      { value: "unsure", label: "I'm not sure" },
    ],
  },
  {
    id: "q5",
    title: "When did you last review your life insurance beneficiaries?",
    type: "single",
    options: [
      { value: "within_year", label: "Within the last year" },
      { value: "1_3_years", label: "1–3 years ago" },
      { value: "over_3_years", label: "More than 3 years ago" },
      { value: "never", label: "I've never reviewed them" },
      { value: "unsure", label: "I'm not sure" },
    ],
  },
  {
    id: "q6",
    title: "Does someone you trust know where to find your important financial and estate documents?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "some", label: "Some of them" },
      { value: "unsure", label: "I'm not sure" },
    ],
  },
  {
    id: "q7",
    title: "Do you currently have a financial power of attorney?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "unsure", label: "I'm not sure" },
    ],
  },
  {
    id: "q8",
    title: "Do you currently have healthcare directives or a healthcare power of attorney?",
    type: "single",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "unsure", label: "I'm not sure" },
    ],
  },
  {
    id: "q9",
    title: "If something happened to you, how confident are you that your family would know what to do financially?",
    type: "single",
    options: [
      { value: "very", label: "Very confident" },
      { value: "somewhat", label: "Somewhat confident" },
      { value: "not_very", label: "Not very confident" },
      { value: "not_at_all", label: "Not confident at all" },
    ],
  },
  {
    id: "q10",
    title: "What is your biggest legacy-planning concern?",
    subtitle: "Select all that apply.",
    type: "multi",
    options: [
      { value: "protecting_family", label: "Protecting my family" },
      { value: "probate", label: "Avoiding unnecessary probate complications" },
      { value: "protecting_home", label: "Protecting my home" },
      { value: "life_insurance", label: "Life insurance" },
      { value: "leaving_money", label: "Leaving money to children/grandchildren" },
      { value: "final_expenses", label: "Final expenses" },
      { value: "organizing_documents", label: "Organizing important documents" },
      { value: "wills_trusts", label: "Understanding wills and trusts" },
      { value: "healthcare_decisions", label: "Healthcare decisions" },
      { value: "not_sure", label: "I'm not sure where to start" },
    ],
  },
];
